export default __webpack_public_path__ + "static/media/border.5b1ca018.svg";